import { render } from "./BaseDocumentSettings.vue?vue&type=template&id=c99cc59c"
import script from "./BaseDocumentSettings.vue?vue&type=script&lang=js"
export * from "./BaseDocumentSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__